export const features = [
  {
    id: 'f1',
    title: '智能兴趣匹配',
    description: '基于多维度兴趣算法，精准推荐志同道合的伙伴，匹配度一目了然，让每一次相遇都充满惊喜。',
    icon: 'ri-heart-pulse-line',
    color: 'primary' as const,
  },
  {
    id: 'f2',
    title: '多元内容分享',
    description: '支持图文、短视频等多种形式的内容创作，用成长日记记录生活的每一个精彩瞬间。',
    icon: 'ri-image-add-line',
    color: 'accent' as const,
  },
  {
    id: 'f3',
    title: '兴趣圈子社区',
    description: '超过500个兴趣圈子等你加入，从读书到户外，从音乐到美食，总有属于你的社群。',
    icon: 'ri-group-line',
    color: 'secondary' as const,
  },
  {
    id: 'f4',
    title: '成长伙伴系统',
    description: '与好友结成成长伙伴，互相监督、互相鼓励，让社交真正促进彼此的进步与成长。',
    icon: 'ri-user-star-line',
    color: 'primary' as const,
  },
  {
    id: 'f5',
    title: '线下活动联动',
    description: '定期举办各类主题线下活动，从线上走到线下，让虚拟友谊在现实中生根发芽。',
    icon: 'ri-calendar-event-line',
    color: 'accent' as const,
  },
  {
    id: 'f6',
    title: '隐私安全保障',
    description: '业界领先的数据加密技术，精细的隐私设置选项，让你放心享受社交的乐趣。',
    icon: 'ri-shield-check-line',
    color: 'secondary' as const,
  },
];

export const stats = [
  { label: '注册用户', value: '500万+', icon: 'ri-user-line' },
  { label: '兴趣圈子', value: '500+', icon: 'ri-group-line' },
  { label: '日均匹配', value: '100万+', icon: 'ri-heart-pulse-line' },
  { label: '线下活动', value: '3000+', icon: 'ri-calendar-event-line' },
];

export const testimonials = [
  {
    id: 't1',
    name: '小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20casual%20style%20warm%20smile%20natural%20lighting%20clean%20simple%20background&width=100&height=100&seq=avatar-user-01&orientation=squarish',
    role: '大学生',
    content: '雏鸟app真的改变了我的大学生活。通过兴趣匹配认识了一群同样热爱摄影的朋友，我们经常一起出去拍照，感觉太棒了！',
    rating: 5,
  },
  {
    id: 't2',
    name: '阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20casual%20style%20friendly%20expression%20natural%20lighting%20clean%20simple%20background&width=100&height=100&seq=avatar-user-02&orientation=squarish',
    role: '职场新人',
    content: '刚来北京工作的时候很孤独，是雏鸟app帮我找到了跑步圈子。现在每周都和大家一起跑，不仅有了朋友，身体也更好了。',
    rating: 5,
  },
  {
    id: 't3',
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20artistic%20style%20gentle%20smile%20natural%20lighting%20clean%20simple%20background&width=100&height=100&seq=avatar-user-03&orientation=squarish',
    role: '自由插画师',
    content: '在雏鸟app的绘画圈子里认识了很多同行，大家互相交流作品、分享接单经验，真的对我的职业发展帮助很大。',
    rating: 5,
  },
  {
    id: 't4',
    name: '浩然',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20sporty%20style%20confident%20smile%20natural%20lighting%20clean%20simple%20background&width=100&height=100&seq=avatar-user-04&orientation=squarish',
    role: '研究生',
    content: '雏鸟app的兴趣匹配太准了！推荐给我的几个朋友，聊起来完全不会尴尬，感觉就像认识了很久一样。',
    rating: 4,
  },
  {
    id: 't5',
    name: '晓雯',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20fresh%20style%20bright%20smile%20natural%20lighting%20clean%20simple%20background&width=100&height=100&seq=avatar-user-05&orientation=squarish',
    role: '咖啡馆店主',
    content: '通过雏鸟app的美食圈子，我的小店被越来越多人知道。现在每周都有app上认识的朋友来打卡，生意好了好几倍！',
    rating: 5,
  },
];

export const faqs = [
  {
    question: '雏鸟app是免费的吗？',
    answer: '雏鸟app基础功能完全免费，包括注册、智能匹配、聊天、发布动态等核心功能。部分高级功能（如查看访客记录、超级匹配等）需要开通会员，会员价格亲民，月费仅需¥12。',
  },
  {
    question: '如何保证匹配的准确性？',
    answer: '雏鸟app采用自研的多维兴趣匹配算法，从音乐、电影、阅读、运动、旅行、生活方式等十余个维度进行综合分析。你的兴趣问卷填写越详细，匹配结果就越精准。系统还会根据你的互动行为持续优化匹配模型。',
  },
  {
    question: '我的个人信息安全吗？',
    answer: '我们非常重视用户隐私。雏鸟app采用银行级数据加密技术，所有敏感信息在传输和存储过程中都经过加密处理。你还可以在隐私设置中精确控制每项信息的可见范围。我们承诺不会出售用户数据给任何第三方。',
  },
  {
    question: '雏鸟app支持哪些平台？',
    answer: '雏鸟app目前支持iOS（14.0及以上）和Android（8.0及以上）两大主流平台。你可以在App Store和各大安卓应用商店搜索「雏鸟」下载。网页版正在紧锣密鼓地开发中。',
  },
  {
    question: '如何在雏鸟app上找到志同道合的朋友？',
    answer: '首先完成详细的兴趣问卷，这是匹配的基础。然后可以主动使用「发现」功能搜索特定兴趣标签的用户，也可以加入你感兴趣的圈子参与讨论。保持活跃，积极参与圈子和线下活动，你很快就能找到志同道合的朋友。',
  },
  {
    question: '遇到不友善的用户怎么办？',
    answer: '雏鸟app建立了完善的社区规范。如果遇到骚扰或不友善行为，你可以将对方加入黑名单，或通过举报功能向我们反馈。我们的审核团队会在24小时内处理举报，确保社区环境友善安全。',
  },
];